/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Post_Purchase_Upload_CtaInputs */

const en_post_purchase_upload_cta = /** @type {(inputs: Post_Purchase_Upload_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click here to upload`)
};

const es_post_purchase_upload_cta = /** @type {(inputs: Post_Purchase_Upload_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz clic aquí para subirlo`)
};

/**
* | output |
* | --- |
* | "Click here to upload" |
*
* @param {Post_Purchase_Upload_CtaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const post_purchase_upload_cta = /** @type {((inputs?: Post_Purchase_Upload_CtaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Post_Purchase_Upload_CtaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_post_purchase_upload_cta(inputs)
	return en_post_purchase_upload_cta(inputs)
});